import React from 'react';
import { Button } from '@guildeducationinc/recess';
import { AutocompleteState, BaseItem } from '@algolia/autocomplete-core';
import { onModalClose } from '@src/components/SearchBar/searchBarHelpers';
import { trackEvent } from '@src/services/analytics';
import styles from './ProgramsFooter.module.scss';

interface Props {
	page: number;
	refine: (value: string) => void;
	state: AutocompleteState<BaseItem>;
}

export const ProgramsFooter: React.FC<Props> = ({ refine, page, state }) => {
	return (
		<>
			{Number(state.context.nbPrograms) > 3 && (
				<Button
					className={styles.searchButton}
					data-testid='programs-plugin-footer'
					onClick={() => {
						refine(state.query);
						trackEvent('Search', {
							searchState: {
								pageNumber: page + 1,
								sourceId: 'programsPlugin',
							},
							typedTerm: state.query,
						});
						onModalClose();
					}}
				>
					See all results for &quot;{state.query}&quot; ({state.context.nbPrograms})
				</Button>
			)}
		</>
	);
};
